import { all, put, takeLatest } from "redux-saga/effects";
import { defaultApi } from "../../../utils/axiosApi";
import {
  GET_DATE_FORMAT,
  GET_DATE_FORMAT_FAILURE,
  GET_DATE_FORMAT_SUCCESS,
  UPDATE_DATE_FORMAT,
  UPDATE_DATE_FORMAT_FAILURE,
  UPDATE_DATE_FORMAT_SUCCESS,
  UPDATE_START_WEEK_DAY,
  UPDATE_START_WEEK_DAY_SUCCESS,
  UPDATE_START_WEEK_DAY_FAILURE
} from "../../../modules/constants";


export function* updateStartDayOfWeekRequest({ payload }) {
  const { organization_id, configuration_id, ...details } = payload;
  try {
    const url = `${organization_id}/features/start-day-of-week-setting/${configuration_id}/`;
    const response = yield defaultApi(url, "PATCH", details);
    yield put({
      type: UPDATE_START_WEEK_DAY_SUCCESS,
      payload: { data: response, notify: "PATCH" },
    });
  } catch (err) {
    yield put({
      type: UPDATE_START_WEEK_DAY_FAILURE,
      payload: err,
    });
  }
}

export function* getDateFormatRequest({ payload }) {
  const { organization_id, configuration_id } = payload;

  try {
    const url = `${organization_id}/features/date-format-setting/${configuration_id}/`;
    const response = yield defaultApi(url, "GET");

    yield put({
      type: GET_DATE_FORMAT_SUCCESS,
      payload: { data: response, notify: "GET" },
    });
  } catch (err) {
    yield put({
      type: GET_DATE_FORMAT_FAILURE,
      payload: err,
    });
  }
}

export function* updateDateFormatRequest({ payload }) {
  const { organization_id, configuration_id, ...details } = payload;

  try {
    const url = `${organization_id}/features/date-format-setting/${configuration_id}/`;
    const response = yield defaultApi(url, "PATCH", details);

    yield put({
      type: UPDATE_DATE_FORMAT_SUCCESS,
      payload: { data: response, notify: "PATCH" },
    });
  } catch (err) {
    yield put({
      type: UPDATE_DATE_FORMAT_FAILURE,
      payload: err,
    });
  }
}

export default function* root() {
  yield all([
    takeLatest(UPDATE_DATE_FORMAT, updateDateFormatRequest),
    takeLatest(GET_DATE_FORMAT, getDateFormatRequest),
    takeLatest(UPDATE_START_WEEK_DAY, updateStartDayOfWeekRequest),
  ]);
}
